import {AfterViewInit, Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import { UntypedFormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { PatternValidator } from '../../shared/pattern-validator';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ProfileService} from "../../services/profile/profile.service";
import {IsDirty} from "../../services/can-deactivate-guard/is-dirty.interface";
import {WarningModalService} from "../../services/warning-modal/warning-modal.service";
import {Observable, of} from "rxjs";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-password-update-modal',
  templateUrl: './password-update-modal.component.pug',
  styleUrls: ['./password-update-modal.component.scss'],
  standalone: false
})
export class PasswordUpdateModalComponent implements OnInit, AfterViewInit, IsDirty {

  public event: EventEmitter<any> = new EventEmitter();
  @Input() isPasswordReused: string = '';
  @Input() isCurrentPasswordCorrect: string = '';
  current_password = '';
  new_password = '';
  confirm_password = '';
  acceptedChars = "!\"#$%&'()*+,-./:;<=>?@[]^_`{|}~"
  messages = [];
  passwordPolicyFeatureFlag: Boolean = false;
  ent_9105_penetration_test_2025: Boolean = false;
  @ViewChild('setPasswordFormRef', {static: false}) passwordForm: any;
  setPasswordForm = this.fb.group({
    current_password: ['', [Validators.required]],
    new_password: ['', [Validators.required,
                    Validators.minLength(12),
                    PatternValidator.pattern(/\d/, { hasNumber: true}),
                    PatternValidator.pattern(/[A-Z]/, { hasUpperCase: true}),
                    PatternValidator.pattern(/[a-z]/, { hasLowerCase: true}),
                    PatternValidator.pattern(/[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~]/, { hasSpecialChar: true})
                   ]
              ],
    confirm_password: ['', [Validators.required]],
  },
  {
    validator: PatternValidator.passwordMatchValidator
  });
  deprecated_setPasswordForm = this.fb.group({
    current_password: ['', [Validators.required]],
    new_password: ['', [Validators.required,
                    Validators.minLength(8),
                    PatternValidator.pattern(/\d/, { hasNumber: true}),
                    PatternValidator.pattern(/[A-Z]/, { hasUpperCase: true}),
                    PatternValidator.pattern(/[a-z]/, { hasLowerCase: true}),
                    PatternValidator.pattern(/[!"#$%&'()*+,-./:;<=>?@\[\]^_`{|}~]/, { hasSpecialChar: true})
                   ]
              ],
    confirm_password: ['', [Validators.required]],
  },
  {
    validator: PatternValidator.passwordMatchValidator
  });
  showValidationError = false;

  constructor(private fb: UntypedFormBuilder,
              private profile: ProfileService,
              public _bsModalRef: BsModalRef,
              private modal: WarningModalService,
              private permissions: PermissionsService) {
  }

  ngOnInit(): void {
    this.passwordPolicyFeatureFlag = this.permissions.isFeatureActivated('ENT_7705_SIGNUP_PASSWORD_POLICY');
    this.ent_9105_penetration_test_2025 = this.permissions.isGlobalFeatureActivated('ENT-9105-PENETRATION-TEST-2025');
  }
  get f() {
    return this.ent_9105_penetration_test_2025 ? this.setPasswordForm.controls : this.deprecated_setPasswordForm.controls;
  }

  ngAfterViewInit(): void {
    let pwd_field_togglers = document.querySelectorAll("[id='toggle-password']");
    // @ts-ignore
    for(let pwd_field_toggler of pwd_field_togglers) {
      pwd_field_toggler.addEventListener("click", this.toggleShowPassword);
    }
  }

  cancel() {
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    this.messages = [];
    this.showValidationError = true;
    if (this.passwordPolicyFeatureFlag) {
      this.isCurrentPasswordCorrect = '';
      this.isPasswordReused = '';
    }
    if (this.ent_9105_penetration_test_2025 ? this.setPasswordForm.invalid : this.deprecated_setPasswordForm.invalid) {
      return;
    }
    this.event.emit({'password': this.f.current_password.value, 'new_password': this.f.new_password.value});
  }


  isDirty(): boolean {
    return this.ent_9105_penetration_test_2025 ? this.setPasswordForm.dirty : this.deprecated_setPasswordForm.dirty;
  }

  markAsPristine() {
    this.ent_9105_penetration_test_2025 ? this.setPasswordForm.markAsPristine() : this.deprecated_setPasswordForm.markAsPristine();
  }

  canDeactivate(): Observable<boolean> {
    // If component is dirty, warn user
    if (this.isDirty()) {
      let title = $localize`Leave this page?`;
      let message = $localize`All information you have added will be lost if you navigate away.\n\nDo you want to leave this page?`;
      let cancelButton = $localize`Stay on page`;
      let agreeButton = $localize`Leave this page`;
      return this.modal.confirm(title= title, message= message, false, cancelButton, agreeButton, true);
    } else {
      return of(true);
    }
  }

  setMessages(newMessages) {
    this.messages = this.messages.concat(newMessages);
  }

  toggleShowPassword() {
    let passwordInput = document.querySelector("[name='current_password']");
    // @ts-ignore
    passwordInput.type = passwordInput?.type === "password" ? "text" : "password";
    passwordInput = document.querySelector("[name='new_password']");
    // @ts-ignore
    passwordInput.type = passwordInput?.type === "password" ? "text" : "password";
    passwordInput = document.querySelector("[name='confirm_password']");
    // @ts-ignore
    passwordInput.type = passwordInput?.type === "password" ? "text" : "password";
  }
}
